import { reviewTab } from "../../../pages/applications/applicationDetail/model";
import { ReviewAction, sendReviewEvent } from "../../../components/matomoClient";
import { ModalMessage } from "../../../common/data/ModalMsg";
import { AsyncActionButtonOrLink } from "../../../components/asyncActionButtonOrLink";
import { TooltipMessage } from "../../../common/data/TooltipMsg";
import { CalendarOutlined } from "@ant-design/icons";
import { Input, Spin } from "antd";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { IsFeatureEnabledOrNot } from "src/FeatureToggles/FeatureEnabledOrNot";
import { ToggleList } from "src/FeatureToggles/toggleList";
import { getSavedReviewTasks } from "src/pages/applications/applicationDetail/service";
import { isNullOrEmptyString, isNullOrUndefined } from "src/common/utils";

const { TextArea } = Input;

export function CloseReviewModalContent({
  getReviewTicket,
  setDisabled,
  setComment,
  refreshTicket,
  loading,
  setLoading,
  latestReviewId,
  isItgc,
  isCancelPopup,
  comment
}) {
  const [tickets, setTickets] = useState(undefined);
  const [savedTasksCount, setSavedTasksCount] = useState(0);

  const onChange = (e) => {
    let comment = e.target.value;
    setComment(comment);
  };

  const isSaveAsDraftFeatureEnabled = IsFeatureEnabledOrNot(ToggleList.SaveAsDraft)
  useEffect(async () => {
    if (!isNullOrUndefined(latestReviewId)) {
      var openTicketCount = 0;
      var savedCount = 0;
      if (getReviewTicket) {
        await getReviewTicket().then((result) => {
          openTicketCount = result?.tickets.filter(
            (t) => t.status !== "CLOSED" && t.status !== "SOLVED"
          ).length;
          setTickets(openTicketCount);
        });
      }
      if (isNullOrUndefined(isCancelPopup) || isCancelPopup === false) {
        await getSavedReviewTasks(latestReviewId).then((result) => {
          savedCount = result?.length;
          setSavedTasksCount(savedCount);
        });
      }
      handleDisable(openTicketCount, savedCount)
      setLoading(false);
    }
  }, [refreshTicket, latestReviewId]);

  useEffect(() => {
    if (isCancelPopup && isNullOrEmptyString(comment)) {
      setDisabled(true);
    } else if (isCancelPopup) {
      setDisabled(false);
    }
  }, [comment])

  function handleDisable(openTicketCount, savedCount) {
    if (openTicketCount > 0 || savedCount || isCancelPopup) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }

  function commentPlaceHolder() {
    return (isCancelPopup === true) ? "Reason for canceling review" : "Comment for closing review (optional)"
  }

  return (
    <div>
      <Spin spinning={loading}>
        {(tickets > 0 || (isSaveAsDraftFeatureEnabled && savedTasksCount > 0)) ? (
          <div>
            <span
              style={{
                fontSize: "14px",
                paddingBottom: "8px"
              }}
            >
              Review cannot be {(isCancelPopup === true) ? "canceled" : "closed"}. Please check the issues mentioned below
            </span>
            <ol style={{ paddingInlineStart: "14px" }}>
              {
                (tickets > 0) ? (
                  <>
                    <li style={{ color: "red", fontSize: "14px" }}>
                      {ModalMessage.closeReview.ticketConfirmationMsg(tickets)}
                    </li>
                    <p style={{ fontSize: "12px" }}>
                      Please get in touch with the application team to
                      close the tickets before {(isCancelPopup === true) ? "canceling" : "closing"} the review
                    </p>
                  </>
                ) : null
              }
              {
                (isSaveAsDraftFeatureEnabled && savedTasksCount > 0) ?
                  (
                    <>
                      <li style={{ color: "red", fontSize: "14px" }}>
                        Review cannot be closed as {savedTasksCount} review decisions are saved as draft and not been
                        submitted
                      </li>
                      <p style={{ fontSize: "12px" }}>
                        Notify the Access Owners that they need to submit the
                        pending/saved for later review decisions
                      </p>
                    </>
                  ) : null
              }
            </ol>
          </div>
        ) : (
          <div>
            <div>
              {(isCancelPopup === true) ? ModalMessage.cancelReview.confirmationMsg : ModalMessage.closeReview.confirmationMsg}
            </div>
            <TextArea
              onChange={onChange}
              maxLength={1000}
              placeholder={commentPlaceHolder()}
              style={{
                width: 350,
                height: 70,
                fontSize: 14,
                marginTop: 14,
                padding: 10,
                resize: "none",
                borderRadius: "5px",
              }}
              className="close-review-comment"
            />
          </div>
        )}
      </Spin>
    </div>
  );
}

export function ITGCCloseReviewBtn({
  appId,
  appInfo,
  showReviewBtn,
  closeReview,
  refreshAppDetail,
  setActiveTab,
  closeActiveReview,
  refreshReviewHistory,
  getReviewTicket,
  autoClick = false,
  latestReviewId
}) {
  const [comment, setComment] = useState("");
  const [disabled, setDisabled] = useState(true);

  const [refreshTicket, setRefreshTicket] = useState("")
  const [loading, setLoading] = useState(true);

  const closeReviewBtnCallback = () => {
    setRefreshTicket(uuidv4())
  }

  let btn = null;
  let content = null;

  const okText = ModalMessage.closeReview.okText

  const okFn = async () => {
    await closeReview(appId, comment);
    refreshAppDetail();
    setActiveTab(reviewTab.id);
    closeActiveReview();
    refreshReviewHistory();
    sendReviewEvent(ReviewAction.CloseReview, appInfo.name);
  };

  const cancelFn = () => {
    setLoading(true)
  }

  if (showReviewBtn) {
    content = (
      <CloseReviewModalContent
        getReviewTicket={getReviewTicket}
        setDisabled={setDisabled}
        setComment={setComment}
        refreshTicket={refreshTicket}
        loading={loading}
        setLoading={setLoading}
        latestReviewId={latestReviewId}
        isItgc={true}
      />
    );
    btn = (
      <AsyncActionButtonOrLink
        type="button"
        tooltipText={TooltipMessage.closeReview}
        buttonProps={{
          icon: <CalendarOutlined />,
          text: "Close Review",
          authZButtonType: "primary",
          onButtonClick: closeReviewBtnCallback
        }}
        modalProps={{
          content: content,
          title: ModalMessage.closeReview.title,
          className: "start-modal",
          modalType: "closeReview",
        }}
        modalOkButtonProps={{
          okCallback: okFn,
          okText: okText,
          disabled: disabled,
        }}
        modalCancelButtonProps={{
          cancelCallBack: cancelFn
        }}
        displayModal={autoClick}
      />
    );
  }
  return btn;
}
